import { Component } from '@angular/core';
import { LoggerService, LogCategory, LogType, LogCoreComponent } from 'src/app/core/services/logger.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../services/profile.service';

@Component({
    selector: 'error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    standalone: false
})
export class ErrorModalComponent {

    constructor(
        private logger: LoggerService,       
        public activeModal: NgbActiveModal,
        public profileService: ProfileService,
    ) {
        this.log("constructor", "", LogCategory.Constructor);
    }
          
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.ModalError, category);
    }
   
}
